(function() {
    "use strict";

    var URI = require('urijs'),
        // Crypto = require("./shared/Crypto"),
        as_script_loc = URI(window.location.href).search(true).as_script_loc;

    // if (as_script_loc) {
    //     as_script_loc = Crypto.decrypt(as_script_loc.replace(/\s/g, '+'));
    // }

    // Encrypted script location to load from
    if (as_script_loc && !window.as_script_loc_handled && URI(as_script_loc).host().match(/agentshield\.com$/)) {
        var elem = document.getElementsByTagName("head")[0];
        var newScript = document.createElement("script");
        newScript.type = "text/javascript";
        newScript.src = as_script_loc;
        elem.appendChild(newScript);
        window.as_script_loc_handled = true;
        return;
    }

    require('es5-shim');
    require('es5-shim/es5-sham.js');

    var React = require('react'),
        widget = window._WID_.shift(),
        wid = widget.wid;

    // if(widget.wid){
    //     require('react/lib/DOMProperty').ID_ATTRIBUTE_NAME = 'data-reactid-'+(widget.wid);
    // }

    var Application = require('./views/Application'),
        Constants = require('./constants'),
        $ = require('jquery');

    require('../../public/resources/css/app.less');
    require('jquery-migrate');
    require('bootstrap');
    require('backbone');
    require('html5shiv');

    jQuery.noConflict(true);

    $(function() {
        $('<script>!function(t,e,n,a,c,o,i){t.GoogleAnalyticsObject=c,t[c]=t[c]||function(){(t[c].q=t[c].q||[]).push(arguments)},t[c].l=1*new Date,o=e.createElement(n),i=e.getElementsByTagName(n)[0],o.async=1,o.src=a,i.parentNode.insertBefore(o,i)}(window,document,"script","//www.google-analytics.com/analytics.js","__ASGA__"),__ASGA__("create","' + Constants.googleAnalyticsId + '","auto", {"cookieName": "__ASGA__"}),__ASGA__("send","pageview");</script>').appendTo(document.body);
    });

    React.render(React.createElement(Application, {widgetId: widget.wid, agentEmail: widget.agentEmail, widgetLookup: widget.widget}), document.getElementById('AgentShield_MyDevelopments'+(wid ? ('_'+wid) : '')));
})(this);
